import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BaseComponent } from 'src/app/core/base/base.component';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { TURN } from '../turn.constants';
import { TurnDialogService } from './turn.dialog.service';

@Component({
  selector: 'ms-common-turn-dialog',
  templateUrl: './turn.dialog.component.html',
})
export class TurnDialogComponent extends BaseComponent {
  readonly screen = TURN;
  isPatch = false;
  isPatchDoctor = false;
  isPatchStatus = false;
  turnId?: number;
  patientHelp?: CommonPatientViewModel;
  specialtyCodeAlt?: string;
  specialty?: string;

  constructor(
    protected ref: DynamicDialogRef,
    protected config: DynamicDialogConfig,
    protected service: TurnDialogService
  ) {
    super();
  }

  onInit = () => {
    this.isPatch = this.config.data.turnId != null;
    this.isPatchDoctor = this.config.data.isPatchDoctor;
    this.isPatchStatus = this.config.data.isPatchStatus;
    this.turnId = this.config.data.turnId;
    this.patientHelp = this.config.data.patientHelp;
    this.specialtyCodeAlt = this.config.data.specialtyCodeAlt;
    this.specialty = this.config.data.specialty;
    this.subscriptions.push(
      this.service.getFormSavedStore().subscribe(({ turn, formSaved }) => {
        if (formSaved) {
          this.ref.close(turn);
          this.service.setFormSaved({}, false);
          const goToConsult = this.config.data.goToConsult;

          if (
            turn.isDoctorRole &&
            goToConsult &&
            turn.turnStatusCodeAlt?.toLowerCase() === 'in-progress'
          ) {
            goToConsult(turn);
          }
        }
      })
    );
  };

  saveSubscribe = ($event: boolean) => {};
}
